import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { HttpCancelService, UserService } from '@app/shared/services';
import { API_SUFFIXES_TO_SKIP_BEARER_TOKEN_HEADERS, AuthenticationModuleApiSuffixModels, SharedModuleApiSuffixModels } from '@app/shared/utils';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared/utils/sales-module.enums';
import { Observable } from 'rxjs';
import { retry, takeUntil } from 'rxjs/operators';
import { RxjsService } from '../rxjs.services';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management/shared/enums/configurations.enum';
@Injectable({ providedIn: 'root' })
export class ApiPrefixInterceptor implements HttpInterceptor {
  constructor(private rxjsService: RxjsService, private router: Router, private httpCancelService: HttpCancelService,
    private userService: UserService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.rxjsService.setGlobalLoaderProperty(true);
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(SharedModuleApiSuffixModels.NOTIFICATIONS) || request.url.includes(AuthenticationModuleApiSuffixModels.REFRESH_TOKEN_V2) ||
      request.url.includes(SalesModuleApiSuffixModels.SALES_API_UX_DYNAMIC) || request.url.includes(SharedModuleApiSuffixModels.MICROSOFT_ENDPOINT)
    ||request.url.includes(EventMgntModuleApiSuffixModels.DISPATCHER_STACK_VIEW_FEED_OCCURRENCE_BOOK_MIRROR)
    ||request.url.includes(EventMgntModuleApiSuffixModels.PHONER_STACK_VIEW_FEED_OCCURRENCE_BOOK_MIRROR)) {
      this.rxjsService.setGlobalLoaderProperty(false);
      this.rxjsService.setPopupLoaderProperty(false);
    }
    // check whether to append bearer token in authorization token header based on requests
    if (!API_SUFFIXES_TO_SKIP_BEARER_TOKEN_HEADERS.some((v) => request.urlWithParams.indexOf(v) >= 0)) {
      // append bearer token for every server request
      request = this.userService.setTokenHeader(request);
    }
    else {
      //To set the versionToken property on the http request
      if (request.urlWithParams.includes(SharedModuleApiSuffixModels.VERSION) || request.urlWithParams.includes(SharedModuleApiSuffixModels.VERSIONS)) {
        request = this.userService.setVersionTokenHeader(request);
      } else {
        request = this.userService.setHeaderWithoutToken(request);
      }
    }
    // retry http request again when the server request gets error
    let retryNoOfTimes = true ? 0 : 1;
    if (request.url.includes('telephony') && request.method == 'POST') {
      return next.handle(request)
    }
    else {
      let notifier1 = (request.url.includes('pageIndex') || request.method !== 'GET') ? this.httpCancelService.onCancelPendingRequestsOnFormSubmission() : null;
      if (notifier1) {
        return next.handle(request).pipe(
          takeUntil(this.httpCancelService.onCancelPendingRequestsOnNavigationChanged()),
          takeUntil(notifier1),
          retry(retryNoOfTimes)
        );
      }
      else {
        return next.handle(request).pipe(
          takeUntil(this.httpCancelService.onCancelPendingRequestsOnNavigationChanged()),
          retry(retryNoOfTimes)
        );
      }
    }
  }
}